import { CSSProperties } from "react";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const focusColor = colors.blueSky.darker;
export const busyColor = colors.peach.lighter;
export const barBg = greys.paleGrey;

export const container: CSSProperties = {
  width: "100%",
};

export const legendRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  fontSize: 14,
};

export const uncrawledMsg: CSSProperties = {
  fontStyle: "italic",
  color: greys.slate,
};

export const focusDot: CSSProperties = {
  backgroundColor: focusColor,
  height: 11,
  width: 11,
  borderRadius: "50%",
  marginRight: 2,
};

export const focusHours: CSSProperties = {
  fontWeight: 600,
  margin: "0 5px",
};

const baseLabel: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  marginLeft: "auto",
};

export const goodLabel: CSSProperties = {
  ...baseLabel,
  color: colors.green.darker,
};

export const badLabel: CSSProperties = {
  ...baseLabel,
  color: colors.red.standard,
};

export const barContainer: CSSProperties = {
  position: "relative",
  width: "100%",
  height: 10,
  marginTop: 5,
};

export const goalIndicator: CSSProperties = {
  position: "absolute",
  top: 0,
  bottom: 0,
  borderLeft: `1px dashed ${greys.slate}`,
};
